import React, { Component } from "react";
import ReactDOM from "react-dom";

function imgUrl(path) {
  if (!path || path.startsWith("http")) return path;
  return `${process.env.PUBLIC_URL}/${path}`;
}

class ProjectDetailsModal extends Component {
  constructor(props) {
    super(props);
    this.state = { imgIndex: 0 };
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
    document.body.style.overflow = "hidden";
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    document.body.style.overflow = "";
  }

  handleKeyDown(e) {
    if (e.key === "Escape") this.props.onClose();
    if (e.key === "ArrowRight") this.nextImg();
    if (e.key === "ArrowLeft") this.prevImg();
  }

  nextImg() {
    const total = this.props.data.images.length;
    this.setState((s) => ({ imgIndex: (s.imgIndex + 1) % total }));
  }

  prevImg() {
    const total = this.props.data.images.length;
    this.setState((s) => ({ imgIndex: (s.imgIndex - 1 + total) % total }));
  }

  render() {
    const { data, onClose, ui = {} } = this.props;
    if (!data) return null;

    const { title, description, myRole, images, technologies, url } = data;
    const { imgIndex } = this.state;
    const hasMultiple = images && images.length > 1;

    return ReactDOM.createPortal(
      <div
        className="modal-overlay"
        onClick={(e) => e.target === e.currentTarget && onClose()}
      >
        <div className="modal-box">
          <button className="modal-close-btn" onClick={onClose}>
            ✕
          </button>

          {images && images.length > 0 && (
            <div className="modal-gallery">
              <img
                src={imgUrl(images[imgIndex])}
                alt={`${title} screenshot ${imgIndex + 1}`}
              />
              {hasMultiple && (
                <>
                  <button
                    className="gallery-btn gallery-prev"
                    onClick={() => this.prevImg()}
                  >
                    ←
                  </button>
                  <button
                    className="gallery-btn gallery-next"
                    onClick={() => this.nextImg()}
                  >
                    →
                  </button>
                  <div className="gallery-dots">
                    {images.map((_, i) => (
                      <button
                        key={i}
                        className={`g-dot${i === imgIndex ? " active" : ""}`}
                        onClick={() => this.setState({ imgIndex: i })}
                      />
                    ))}
                  </div>
                </>
              )}
            </div>
          )}

          <div className="modal-content-body">
            <div className="modal-title">{title}</div>
            <p className="modal-desc">{description}</p>

            {myRole && (
              <div className="modal-role">
                <span className="modal-role-label">{ui.proj_role_label || "My contribution"}</span>
                <p className="modal-role-text">{myRole}</p>
              </div>
            )}

            {technologies && technologies.length > 0 && (
              <div className="modal-tech">
                {technologies.map((t, i) => (
                  <span className="modal-tech-tag" key={i}>
                    <i className={t.class}></i>
                    {t.name}
                  </span>
                ))}
              </div>
            )}

            {url && (
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="modal-link"
              >
                {ui.proj_view || "View Project →"}
              </a>
            )}
          </div>
        </div>
      </div>,
      document.body
    );
  }
}

export default ProjectDetailsModal;
